// extracted by mini-css-extract-plugin
export default {"imageContainer":"Cfa-z","summaryPar":"Dfa-z","ratingCategories":"Efa-z","reviewerInfo":"Ffa-z","reviewTypes":"Gfa-z","expanded":"Hfa-z"};